import axios from 'axios'
axios.defaults.withCredentials = true
// const domain = 'https://100fc1e2ad16.ngrok-free.app'
const domain = process.env.NODE_ENV === 'production' ? 'https://board-restrictor-back-production.up.railway.app' : 'http://localhost:3030'

async function getExistingBoardRestrictions(accountId, accessToken) {
  const accountRestrictions = await axios.get(`${domain}/restriction/account/${accountId}`, {
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
  })
  return accountRestrictions.data
}

async function editRestriction(restriction, accountId, accessToken) {
  const filteredRestriction = _filterRestriction(restriction)
  const updatedRestriction = await axios.put(`${domain}/restriction/board/${restriction._id}/${accountId}`, filteredRestriction, {
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
  })
  return updatedRestriction
}

async function updateRestrictionAccount(restrictionAccount, accessToken) {
  const updatedAccount = await axios.put(`${domain}/restriction/board`, restrictionAccount, {
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
  })
  return updatedAccount
}

async function updateRestrictionAccountKey(key, value, accountId, accessToken) {
  const updatedAccount = await axios.put(
    `${domain}/restriction/board/${accountId}`,
    { key, value },
    {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    }
  )
  return updatedAccount
}


async function deleteRestriction(restrictionId, accountId, accessToken) {
  try {
    const deletedRestriction = await axios.delete(`${domain}/restriction/board/${restrictionId}/${accountId}`, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    })
    return deletedRestriction
  } catch (err) {
    console.log('file: restrictorService.js:56 -> err:', err)
    throw err
  }
}

async function addBoardRestriction(restriction, accountId, accessToken) {
  process.env.NODE_ENV === 'development' && console.log('file: restrictorService.js:23 -> restriction', restriction)
  const filteredRestriction = _filterRestriction(restriction)

  const newRestriction = await axios.post(`${domain}/restriction/board/${accountId}`, filteredRestriction, {
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
  })
  return newRestriction.data
}

async function updateSettingsKey(key, value, accountId, accessToken) {
  console.log(`${domain}/restriction/settings/${accountId}`)
  const updatedAettings = await axios.put(
    `${domain}/restriction/settings/${accountId}`,
    { key, value },
    {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    }
  )
  return updatedAettings
}

function _filterRestriction(restriction) {
  const filteredRestriction = {
    boardId: restriction?.board?.value,
    columnIds: restriction.columns.map((rest) => rest?.value),
    groupId: restriction?.group?.value,
  }
  return filteredRestriction
}

export const restrcitorService = {
  getExistingBoardRestrictions,
  editRestriction,
  deleteRestriction,
  addBoardRestriction,
  updateRestrictionAccount,
  updateRestrictionAccountKey,
  updateSettingsKey
}
